<template lang="pug">
.order-success-panel.modal-content.modal-success
  template(v-if="createdBonus")
    .modal-title BONO CREADO
    p.success-lead
      | Se creó con éxito el bono&nbsp;
      strong.uppercase {{ createdBonus.bonus }}
      | &nbsp;por&nbsp;
      strong {{ money(createdBonus.originalValue) }}
      | . Así verás este bono en la tienda en métodos de pago:

    RefundBonusPreviewRow(
      :bonus-code="createdBonus.bonus"
      :original-value="createdBonus.originalValue"
      :remaining-value="createdBonus.remainingValue"
      :status="createdBonus.status"
    )

    .inline-notice.inline-notice--success
      strong Ya puedes usar este bono
      |  al pagar en la tienda: aplícalo en el paso de métodos de pago.

  template(v-else)
    .modal-title SOLICITUD REGISTRADA
    p.success-lead(v-if="refundId")
      | Tu solicitud de reembolso&nbsp;
      | quedó registrada.&nbsp;
      strong Tu número de solicitud es la&nbsp;
      strong.uppercase {{ refundId }}
    p.success-lead(v-else) Tu solicitud de reembolso quedó registrada. Conserva el comprobante de envío.

  .modal-section-title Próximo paso: Envío
  RefundShippingInstructions(:order-number="displayShippingOrder")

  .inline-notice.inline-notice--warning(v-if="!createdBonus") Al recibir los productos los revisaremos. Si cumplen las condiciones, procesaremos tu reembolso.

  .modal-actions
    button.button-submit(type="button" @click="$emit('close')") {{ closeLabel }}
</template>

<script>
import mFilters from '@/mixins/filters'
import RefundShippingInstructions from './RefundShippingInstructions.vue'
import RefundBonusPreviewRow from './RefundBonusPreviewRow.vue'

export default {
  name: 'BonusShippingSuccessPanel',

  components: { RefundShippingInstructions, RefundBonusPreviewRow },

  mixins: [mFilters],

  props: {
    createdBonus: {
      type: Object,
      default: null
    },
    refundId: {
      type: String,
      default: null
    },
    shippingOrder: {
      type: String,
      default: ''
    },
    closeLabel: {
      type: String,
      default: 'Cerrar'
    }
  },

  computed: {
    displayShippingOrder () {
      return (
        (this.createdBonus && this.createdBonus.order) ||
        (this.shippingOrder || '')
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
.modal-success
  display flex
  flex-direction column
  text-align left
  padding 2rem 1.5rem
  font-size .95rem
  line-height 1.6

.modal-title
  font-weight 700
  font-size 1.1rem
  margin-bottom 1rem

.success-lead
  margin 0 0 1rem

.modal-section-title
  font-weight 700
  font-size 1rem
  margin 1.25rem 0 .75rem

.modal-actions
  margin-top 1.5rem
  display flex
  justify-content flex-end

.button-submit
  background-color #000
  color #fff
  border none
  padding .6rem 1.5rem
  font-size 1rem
  font-family inherit
  cursor pointer
  text-transform uppercase
  font-weight 600

.inline-notice
  margin-top .75rem
  padding .65rem .85rem
  font-size .88rem
  line-height 1.55

.inline-notice--success
  background rgba(81, 165, 64, .12)
  border-left 3px solid #3d7a34
  color #2d5226

.inline-notice--warning
  background rgba(230, 168, 0, 0.12)
  border-left 3px solid #e6a800
  color #7a5a00
</style>



// WEBPACK FOOTER //
// src/components/pages/order/refund/BonusShippingSuccessPanel.vue